import React, { useEffect, useState } from "react";
import './index.css'
import SelectionBar from "../../../common/SelectionBar";
import CloseChip from "../../../common/ActionChip/CloseChip";
import UpdateChip from "../../../common/ActionChip/UpdateChip";
import ActionModal from "../../../common/ActionModal";
import TicketCloseMultiple from "./TicketCloseMultiple";
import { SubmitHandler, useForm } from "react-hook-form";
import { TicketMultipleCloseFormModel, TicketMultipleUpdateFormModel, TicketUpdateFormModel } from "../../../../models/ticket.model";
import { closeMultipleTickets, updateMultipleTickets } from "../../../../services/ticket.service";
import { APIResponseModel } from "../../../../models/api-call";
import { useProject } from "../../../../context/ProjectContext";
import TicketUpdateMultiple from "./TicketUpdateMultiple";
import { useNotification } from "../../../../context/NotificationContext";


interface SelectionMenuBarProps {
  selection: string[]
  onClose?: () => void
  setBlockScreen: (p: boolean) => void
  resetFilter?: () => void
}

const SelectionMenuBar: React.FC<SelectionMenuBarProps> = ({
  selection,
  onClose,
  setBlockScreen,
  resetFilter
}) => {

  const { selectedProject } = useProject()
  const { showNotification } = useNotification()

  const outlineBorderButtons = '#9199c1'

  const [currentSelection, setCurrentSelection] = useState<string[]>(selection)

  const [openModalClose, setOpenModalClose] = useState<boolean>(false)
  const [openModalUpdate, setOpenModalUpdate] = useState<boolean>(false)
  const allModals: boolean[] = [openModalClose, openModalUpdate]

  const [loadingModalChildren, setLoadingModalChildren] = useState<boolean>(true)
  const [transitionModalChildren, setTransitionModalChildren] = useState<boolean>(true)

  const [confirmDisabled, setConfirmDisabled] = useState<boolean>(false)

  type formTypes = TicketMultipleCloseFormModel | TicketUpdateFormModel

  const { handleSubmit } = useForm<formTypes>()

  const defaultTicketMultipleClose: TicketMultipleCloseFormModel = {
    tickets: currentSelection,
    closing_cause: { id: '', label: '' },
    description: '',
    project_code: selectedProject
  }

  const defaultTicketMultipleUpdate: TicketMultipleUpdateFormModel = {
    tickets: currentSelection,
    priority: { id: '', label: '' },
    status: { id: '', label: '' },
    description: '',
    project_code: selectedProject
  }

  const [ticketMultipleCloseForm, setTicketMultipleCloseForm] = useState<TicketMultipleCloseFormModel>(defaultTicketMultipleClose)
  const [ticketMultipleUpdateForm, setTicketMultipleUpdateForm] = useState<TicketMultipleUpdateFormModel>(defaultTicketMultipleUpdate)
  const allForms: Array<[any, React.Dispatch<React.SetStateAction<any>>]> = [
    [ticketMultipleCloseForm, setTicketMultipleCloseForm],
    [ticketMultipleUpdateForm, setTicketMultipleUpdateForm]
  ]

  const onSubmitClose: SubmitHandler<formTypes> = () => {
    setBlockScreen(true);
    Promise.all([closeMultipleTickets(selectedProject, ticketMultipleCloseForm)]).then(function (results: APIResponseModel[]) {
      showNotification(results[0].message)
      if (onClose) onClose()
      if (resetFilter) resetFilter()
      setBlockScreen(false);
    }).catch((error) => {
      showNotification(error.response.data.message ? error.response.data.message : error.response.data)
      setBlockScreen(false);
    });
  };

  const onSubmitUpdate: SubmitHandler<formTypes> = () => {
    setBlockScreen(true);
    Promise.all([updateMultipleTickets(selectedProject, ticketMultipleUpdateForm)]).then(function (results: APIResponseModel[]) {
      showNotification(results[0].message)
      if (onClose) onClose()
      if (resetFilter) resetFilter()
      setBlockScreen(false);
    }).catch((error) => {
      showNotification(error.response.data.message ? error.response.data.message : error.response.data)
      setBlockScreen(false);
    });
  };

  useEffect(() => {
    allForms.map(([form, setter]) => { setter({ ...form, ['tickets']: selection }) })
  }, [selection.length])

  useEffect(() => {
    transitionModalChildren ? setLoadingModalChildren(true) : setTimeout(() => setLoadingModalChildren(false), 800)
  }, [transitionModalChildren])


  useEffect(() => {
    if (allModals.every((item) => item === false)) {
      setTicketMultipleCloseForm(defaultTicketMultipleClose)
      setTicketMultipleUpdateForm(defaultTicketMultipleUpdate)
      setLoadingModalChildren(true)
    }
  }, allModals)


  return (
    <React.Fragment>
      <div className="tickets-listing-secbar-box" >
        <SelectionBar onClose={onClose} selectionCount={selection.length}>
          <CloseChip onClick={() => setOpenModalClose(true)} variant="outline" outlineColor={outlineBorderButtons} label="Cerrar Tickets" />
          <UpdateChip onClick={() => setOpenModalUpdate(true)} outlineColor={outlineBorderButtons} label="Actualizar Tickets" />
        </SelectionBar>
      </div>

      <ActionModal
        title="Cierre Múltiple"
        openModal={openModalClose}
        handleCloseModal={() => setOpenModalClose(false)}
        mode="create"
        handleCreate={handleSubmit(onSubmitClose)}
        removable={false}
        confirmDisabled={confirmDisabled}
        loadingChildren={loadingModalChildren}
      >
        {openModalClose && (
          <TicketCloseMultiple
            setLoadingData={setTransitionModalChildren}
            ticketMultipleCloseForm={ticketMultipleCloseForm}
            setTicketMultipleCloseForm={setTicketMultipleCloseForm}
            action='create'
            setConfirmDisabled={setConfirmDisabled}
          />
        )}

      </ActionModal>

      <ActionModal
        title="Actualización Múltiple"
        openModal={openModalUpdate}
        handleCloseModal={() => setOpenModalUpdate(false)}
        mode="create"
        handleCreate={handleSubmit(onSubmitUpdate)}
        removable={false}
        confirmDisabled={confirmDisabled}
        loadingChildren={loadingModalChildren}
      >
        {openModalUpdate && (
          <TicketUpdateMultiple
            setLoadingData={setTransitionModalChildren}
            ticketMultipleUpdateForm={ticketMultipleUpdateForm}
            setTicketMultipleUpdateForm={setTicketMultipleUpdateForm}
            action='create'
            setConfirmDisabled={setConfirmDisabled}
          />
        )}

      </ActionModal>

    </React.Fragment>
  );
}

export default SelectionMenuBar;
